// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

// Fix iOS Safari scroll restoration overriding Turbo's scroll-to-top on navigation
document.addEventListener("turbo:render", (event) => {
  if (event.detail?.renderMethod !== "morph") {
    window.scrollTo(0, 0);
  }
});

import "trix";
import "@rails/actiontext";

import { Application } from "@hotwired/stimulus";
import Dropdown from "@stimulus-components/dropdown";

// i18n setup
import i18n, { t } from "./i18n";

// Make i18n available globally for non-module scripts
window.I18n = i18n;
window.t = t;

const application = Application.start();
application.register("dropdown", Dropdown);
